<template>
  <div class="fixed w-full bottom-0 bg-white border-t border-t-gray-300 z-30">
    <div class="flex justify-around my-3">
      <Link
        :href="route('tasks.index')"
        class="flex flex-col space-y-1 items-center justify-center text-sm font-medium hover:border-gray-300 hover:text-gray-700"
        :class="
          routeStartsWith('/admin/tasks')
            ? 'text-gray-900'
            : 'text-gray-500 opacity-50'
        "
      >
        <CheckCircleBroken class="w-5" />
      </Link>
      <Link
        :href="route('files.index')"
        class="flex flex-col space-y-1 items-center justify-center text-sm font-medium hover:border-gray-300 hover:text-gray-700"
        :class="
          routeStartsWith('/admin/files')
            ? 'text-gray-900'
            : 'text-gray-500 opacity-50'
        "
      >
        <Box class="w-5" />
      </Link>
      <Link
        v-if="!isServiceProvider"
        :href="route('insights', currentTenant)"
        class="flex flex-col space-y-1 items-center text-sm font-medium hover:border-gray-300 hover:text-gray-700"
        :class="
          routeStartsWith('/admin/insights')
            ? 'text-gray-900'
            : 'text-gray-500 opacity-50'
        "
      >
        <PieChartOne class="w-5" />
      </Link>
      <Link
        :href="route('settings.organisation.index')"
        class="flex flex-col space-y-1 items-center text-sm font-medium hover:border-gray-300 hover:text-gray-700"
        :class="
          !routeStartsWith('/admin/settings/personal') &&
          routeStartsWith('/admin/settings')
            ? 'text-gray-900'
            : 'text-gray-500 opacity-50'
        "
      >
        <BuildingSix class="w-5" />
      </Link>
      <Link
        :href="route('settings.user.personal')"
        class="flex flex-col space-y-1 items-center text-sm font-medium hover:border-gray-300 hover:text-gray-700"
        :class="
          routeStartsWith('/admin/settings/personal')
            ? 'text-gray-900'
            : 'text-gray-500 opacity-50'
        "
      >
        <UserOne class="w-5" />
      </Link>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";

import {
  CheckCircleBroken,
  Box,
  PieChartOne,
  BuildingSix,
  UserOne,
} from "@/Icons";

const currentTenant = computed(() => usePage().props.tenant);

const { hasPermission, permissions } = inject("permissions");
const isServiceProvider = hasPermission(permissions.limitedAccess);

function routeStartsWith(routeName) {
  const url = location.pathname;
  return url.startsWith(routeName);
}
</script>
